<template>
	<div class="height-100dvh">
		<header class="mob-back-header">
			<img
				class="mr-3"
				@click="$router.go(-1)"
				src="../../assets/mobile/assprog/mobileBackArrow.svg"
				alt=""
			/>
			Interview By Skill
		</header>
		<main class="sai-interview-container">
			<div
				id="hideinmobile"
				class="cand-header d-flex mb-2 justify-content-between"
			>
				<div class="d-flex align-items-center">
					<img
						class="mr-3 d-flex pointer"
						src="../../assets/img/homepage/back-arrow-blue.svg"
						alt=""
						@click="$router.go(-1)"
					/>
					Interview By Skill
				</div>
				<!-- <b-button class="candash-addBtn d-flex align-items-center gap-2">
					<img src="../../assets/img/aiInterview/white-plus.svg" alt="" /> Add
					Skill
				</b-button> -->
			</div>
			<div class="sai-container">
				<img
					id="hideinlaptop"
					class="w-50 align-self-center"
					src="../../assets/img/aiInterview/inter-back-mob.svg"
					alt=""
				/>
				<div class="dflex-1">
					<div class="fam-mont fw-M fs-24 mob-fs-18 text-blue align-mob-center">
						Choose your skill to be interviewed
					</div>
					<div class="fam-lato fw-R fs-16 mob-fs-13 text-darkgrey sai-mt-12">
						Search for a skill or select one from the list, including your added
						skills, to start the interview
					</div>
				</div>
				<div>
					<div class="fam-mont fw-LM fs-20 mob-fs-13 text-344054">
						Skills from your primary profile
					</div>
					<div
						style="z-index: 5s"
						class="position-relative lap-w-50 mt-2"
						v-closable="{
							exclude: ['searchoption'],
							handler: 'closeSuggestions',
						}"
					>
						<img
							class="resumes-search-image-position"
							src="../../assets/headerSearch.svg"
							alt=""
						/>
						<b-form-input
							class="resumes-search-input"
							placeholder="Search"
							debounce="500"
							v-model="searchQuery"
							@update="getSearchOptions"
							type="search"
							clearable
							@click="showDropdown = true"
						>
						</b-form-input>
						<ul
							ref="searchoption"
							class="sai-select-options"
							v-if="searchOptions.length && showDropdown"
						>
							<li
								v-for="(option, i) in searchOptions"
								:key="i"
								class="search-select-option px-3 py-2"
								@click="selectOption(option)"
							>
								{{ option.text }}
							</li>
						</ul>
					</div>
				</div>
				<div class="sai-left-overflow">
					<template v-if="skillsLoader">
						<div v-for="i in 5" :key="i" class="skill">
							<b-skeleton width="50%"></b-skeleton>
						</div>
					</template>
					<template v-else>
						<div
							class="skill pointer"
							v-for="(skill, index) in skills"
							:key="skill.name"
							:class="skill.selected ? 'selected' : ''"
							@click="toggleSelect(index, skill)"
						>
							<div class="d-flex align-items-center gap-3">
								<img
									src="../../assets/img/aiInterview/skill-uncheck.svg"
									alt=""
									v-if="!skill.selected"
								/>
								<img
									v-else
									src="../../assets/img/aiInterview/skill-check.svg"
									alt=""
								/>
								<span class="fam-mont fw-M fs-14 text-blue">
									{{ skill.name }}
								</span>
							</div>
							<article class="tag" v-if="skill.fromProfile">
								<img
									class="mr-2"
									src="../../assets/img/aiInterview/from-profile.svg"
									alt=""
								/>
								From Profile
							</article>
						</div>
					</template>
				</div>
				<div id="hideinmobile">
					<b-button
						:disabled="selectedSkills.length == 0"
						@click="proceed()"
						class="candash-addBtn"
						>Proceed</b-button
					>
				</div>
				<img
					id="hideinmobile"
					style="position: absolute; right: 0px; bottom: 0px; z-index: 1"
					src="../../assets/img/aiInterview/inter-back.svg"
					alt=""
				/>
			</div>
			<div id="hideinlaptop" class="mobjd-applied-footer w-100 px-3">
				<b-button
					class="candash-addBtn w-100"
					:disabled="selectedSkills.length == 0"
					@click="proceed()"
					>Proceed</b-button
				>
			</div>
		</main>
	</div>
</template>

<script>
import {
	getProfileSkills,
	getSkillSuggestions,
} from "../../utils/apiFunctions";
import { mapGetters } from "vuex";
import toast from "@/components/mixin/toast";
export default {
	name: "AiSkillInterview",
	mixins: [toast],
	data() {
		return {
			searchQuery: "",
			searchOptions: [],
			skills: [],
			selectedSkills: [],
			showDropdown: false,
			skillsLoader: true,
		};
	},
	created() {
		this.getSkills();
	},
	computed: {
		...mapGetters("candidateVUEX", {
			selectedSkillsForInterview: "getSelectedSkillsForInterview",
		}),
	},

	methods: {
		async getSkills() {
			try {
				const res = await getProfileSkills();
				console.log(res.data.data.data);
				if (res.status == 200) {
					this.skills = res.data.data.data.profile_skills;
					this.skillsLoader = false;
					this.skills.forEach((skill, index) => {
						if (this.selectedSkillsForInterview?.name === skill.name) {
							this.toggleSelect(index, skill);
						}
					});
				}
			} catch (error) {
				throw new Error(error);
			}
		},
		async getSearchOptions() {
			try {
				let payload = {
					page: 0,
					count: 10,
					search: this.searchQuery,
				};
				const res = await getSkillSuggestions(payload);
				console.log(res.data.data);
				if (res.status == 200) {
					this.searchOptions = res.data.data.response;
				}
			} catch (error) {
				throw new Error(error);
			}
		},
		selectSkill(index, skill) {
			if (this.selectedSkills.length >= 5) {
				this.errorModal("Error", "You can only select up to 5 skills.");
				return;
			}
			this.skills[index].selected = true;
			this.selectedSkills.push(skill);
			this.$forceUpdate();
		},
		unselectSkill(index, skill) {
			this.skills[index].selected = false;
			this.selectedSkills.splice(this.selectedSkills.indexOf(skill), 1);
			this.$forceUpdate();
		},
		toggleSelect(index, skill) {
			if (this.skills[index].selected) {
				this.unselectSkill(index, {
					name: skill.name,
					expertise_level: skill.expertise_level,
				});
			} else {
				this.selectSkill(index, {
					name: skill.name,
					expertise_level: skill.expertise_level,
				});
			}
		},
		selectOption(option) {
			if (this.selectedSkills.length >= 5) {
				this.errorModal("Error", "You can only select up to 5 skills.");
				this.searchQuery = "";
				this.showDropdown = false;
				return;
			}
			let data = {
				name: option.text,
				fromProfile: false,
				selected: true,
			};
			this.skills.unshift(data);
			this.selectedSkills.unshift({
				name: option.text,
				expertise_level: "beginner",
			});
			this.searchQuery = "";
			this.showDropdown = false;
		},
		closeSuggestions() {
			this.searchQuery = "";
			this.showDropdown = false;
		},
		proceed() {
			if (this.selectedSkills.length == 0) return;
			this.$store.commit(
				"candidateVUEX/setSelectedSkillsForInterview",
				this.selectedSkills
			);
			this.$router.push({
				name: "systemcheck",
				query: { fromAiInterview: true },
			});
		},
	},
};
</script>

<style>
.sai-interview-container {
	background-color: #e9ecef;
	height: calc(100vh - 60px);
	padding: 15px 15px 15px 75px;
	top: 60px;
	position: relative;
	display: flex;
	flex-direction: column;
	width: 100%;
	align-items: center;
}
.sai-interview-container .cand-header {
}
.sai-container {
	display: flex;
	flex-direction: column;
	gap: 30px;
	height: calc(100vh - 148px);
	background: #f0f5ff;
	border: 1px solid #8c8c8c54;
	box-shadow: 0px 4px 8px 0px #0000002b;
	width: 100%;
	position: relative;
	overflow: hidden;
	border-radius: 5px;
	padding: 30px;
}
.sai-container .candash-addBtn {
	font-size: 14px !important;
	font-weight: 700 !important;
	padding: 10px 32px !important;
	width: 350px;
}
.sai-container .dflex-1 {
	width: 50%;
	padding-bottom: 20px;
	border-bottom: 2px dashed #8c8c8c59;
}
.sai-mt-12 {
	margin-top: 8px;
}
.sai-left-overflow {
	height: calc(100vh - 466px);
	overflow: auto;
	width: 50%;
	position: relative;
	z-index: 2;
}
.sai-left-overflow .skill {
	border: 1px solid #20639b1f;
	background-color: #fff;
	border-radius: 8px;
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 10px 12px 10px 16px;
	margin-bottom: 10px;
	width: 100%;
}
.sai-left-overflow .skill:hover {
	background-color: #eff4f8;
}
.sai-left-overflow .skill article {
	font-size: 13px;
	font-weight: 700;
	font-style: italic;
	font-family: "lato", sans-serif;
	border-radius: 12px;
}
.sai-left-overflow .skill.selected {
	border: 1px solid #20639b;
	border-left: 7px solid #20639b;
	background-color: #eff4f8;
	padding: 10px 12px 10px 10px;
}
.sai-left-overflow .skill .tag {
	font-family: "Lato", sans-serif;
	font-weight: 400;
	font-style: Italic;
	font-size: 13px;
	color: #405c77;
}
.sai-select-options {
	position: absolute;
	overflow: auto;
	border: 1px solid #2988e638;
	background-color: #f9f9f9;
	z-index: 6;
	border-radius: 4px;
	width: 100%;
	box-shadow: 0px 8px 15px 0px #00000066;
	list-style-type: none;
	padding-left: 0px;
	max-height: 160px;
	font-size: 14px;
}
.search-select-option {
	cursor: pointer;
	color: #333 !important;
	font-size: 13px !important;
	font-weight: 500 !important;
}

.search-select-options .search-select-option:first-child {
	/* Your styles for the first <li> element */
	color: #8c8c8c !important;
	font-size: 12px !important;
	font-weight: 400;
	font-family: "montserrat", sans-serif;
	background-color: transparent;
}

.search-select-option:hover {
	background-color: #e8eff4;
}

.search-select-option.selected {
	background-color: #c8d9e5;
}
.lap-w-50 {
	width: 50%;
}
@media (max-width: 1028px) {
	.sai-interview-container {
		background-color: #f5f9ff;
		height: calc(
			100dvh - (60px + env(safe-area-inset-top) + env(safe-area-inset-bottom))
		) !important;
		padding: 0px !important;
		overflow: auto !important;
		position: fixed !important;
		top: unset !important;
		display: unset !important;
	}
	.sai-container {
		display: flex;
		flex-direction: column;
		gap: 30px;
		height: 92%;
		background: unset;
		border: unset;
		box-shadow: unset;
		width: 100%;
		position: relative;
		overflow: auto;
		border-radius: 5px;
		padding: 15px;
	}
	.sai-container .dflex-1 {
		width: 100%;
		padding-bottom: 15px;
	}
	.align-mob-center {
		align-self: center;
	}
	.sai-left-overflow {
		height: calc(100vh - 505px);
		overflow: auto;
		min-height: 200px;
		width: 100%;
	}
	.lap-w-50 {
		width: 100%;
	}
}
</style>
